// extracted by mini-css-extract-plugin
export var actionButton = "_ly-0";
export var actionMenuContainer = "_ly-i";
export var bubble = "_ly-2";
export var bubbleActionMenu = "_ly-j";
export var bubbleContext = "_ly-6";
export var bubbleItems = "_ly-7";
export var customer = "_ly-3";
export var divider = "_ly-8";
export var fileList = "_ly-9";
export var hiddenComment = "_ly-o";
export var infoAbove = "_ly-a";
export var internal = "_ly-4";
export var lightActionButton = "_ly-1";
export var link = "_ly-b";
export var merchant = "_ly-5";
export var message = "_ly-c";
export var profilePicture = "_ly-e";
export var quillToolbarContainer = "_ly-f";
export var senderDate = "_ly-g";
export var senderDateCustomer = "_ly-h";
export var senderName = "_ly-d";
export var time = "_ly-k";
export var uploadedImage = "_ly-l";
export var username = "_ly-m";
export var xsmall = "_ly-n";